import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import th from "./locales/th.json";
import en from "./locales/en.json";

// Detect saved language from localStorage, default to Thai
const savedLang = localStorage.getItem("appLanguage") || "th";

i18n.use(initReactI18next).init({
  resources: {
    th: { translation: th },
    en: { translation: en },
  },
  lng: savedLang,
  fallbackLng: "th",
  interpolation: {
    escapeValue: false, // React already escapes by default
  },
});

// Persist language change to localStorage
i18n.on("languageChanged", (lng) => {
  localStorage.setItem("appLanguage", lng);
});

export default i18n;
